import { render, staticRenderFns } from "./SesionesConRecinto.vue?vue&type=template&id=f1122106"
import script from "./SesionesConRecinto.vue?vue&type=script&lang=js"
export * from "./SesionesConRecinto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports